var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var $modal = null,
  $wrapper = null;

function VideoModal(el) {
  var t = this;

  t.$el = $(el),
  t.wrapper = t.$el.find('.video-modal__wrapper');

  if (! $modal) {
    $wrapper = $('<div class="video-modal__wrapper"><span class="video-modal__close icon-close"></span></div>');
    $modal = $('<div class="video-modal"></div>')
    $modal.append($wrapper);
    $modal.appendTo('body');

    $modal.on('click', '.video-modal__close', function() {
      closeModal();
    });

    $modal.not(t.wrapper).on('click', function() {
      closeModal();
    });

    function closeModal() {
      $modal.removeClass('js-video-modal-active');
      $wrapper.children('iframe').remove();
    }
  }

  t.$el.on('click', t.click.bind(t));
}

VideoModal.prototype.click = function (e) {
  var t = this,
    $iframe = $('<iframe>', {
      src: t.$el.attr('href') + '?autoplay=1'
    });
  e.preventDefault();
  $wrapper.children('iframe').remove();
  $wrapper.append($iframe);
  $modal.addClass('js-video-modal-active');
};

module.exports = VideoModal;
